import styles from "../assets/styles/settings.module.css"
function MoreStartOptions({settingsYear, rebuiltMissType, setRebuiltMissType}) {
    function toggle(setter,getter,name) {
        setter(!getter);
        localStorage.setItem(name, String(!getter));
    }

    return (
        <div className={styles.themeOptions}>
            {parseInt(settingsYear) === 2026 && (
                <div className={styles.touchingBox}>
                    <div className={styles.container}>
                        <label className={styles.switch}>
                            <input type="checkbox" checked={rebuiltMissType} onChange={() => toggle(setRebuiltMissType,rebuiltMissType,"rebuiltMissStatus")} />
                            <span className={styles.slider}></span>
                        </label>
                        <span>{rebuiltMissType? "Count Misses Enabled" : "Accuracy Misses Enabled"}</span>
                    </div>
                </div>
            )}
        </div>
    );
}
export default MoreStartOptions;